import { FC } from "react"
import { useNavigate } from "react-router"
import Button, { ButtonIconPosition } from "@/components/shared/Button"
import Grid from "@/components/shared/Grid"
import GridItem from "@/components/shared/Grid/GridItem"
import { Icon, IconColor } from "@/components/shared/Icon"
import { PageRoutes } from "@/constants/routes"
import { useJmsEnabled } from "@/hooks/useJmsEnabled"
import { ButtonVariant } from "@/types/index"
import { getBatteryChargeIcon } from "@/utils/index"
import { compact } from "@/utils/lodash"

interface ControlsProps {
   wearableId: string
   // inmateId: string
   title: string
   chargeLevel: number
   bookingNumber?: string | null
   inmateNumber?: string | null
   housingUnit?: string | null
   housingBlock?: string | null
   housingCell?: string | null
}

const Controls: FC<ControlsProps> = ({
   wearableId,
   // inmateId,
   title,
   chargeLevel,
   bookingNumber,
   inmateNumber,
   housingUnit,
   housingBlock,
   housingCell,
}) => {
   const navigate = useNavigate()
   const jmsEnabled = useJmsEnabled()
   const housingLocation = compact([
      housingUnit,
      housingBlock,
      housingCell,
   ]).join(" – ")
   // const {
   //    isOpen: isWearableModalOpen,
   //    openModal: openWearableModal,
   //    closeModal: closeWearableModal,
   // } = useModal()

   return (
      <>
         <Grid
            flexWrap="nowrap"
            justifyContent="space-between"
            className="inmate-detail-overview__controls"
         >
            <GridItem
               size={10}
               className="inmate-detail-overview__header"
            >
               <Button
                  className="inmate-detail-overview__back-button"
                  iconName="arrowLeft"
                  iconPosition={ButtonIconPosition.LEFT}
                  variant={ButtonVariant.LARGE}
                  onClick={() => navigate(PageRoutes.FLOOR_OVERVIEW)}
               />
               <div className="inmate-detail-overview__title">
                  <div className="inmate-detail-overview__title-label">
                     <div className="inmate-detail-overview__title-section">
                        <Icon
                           name="smartwatch"
                           color={IconColor.COOL_GRAY}
                        />
                        <span>{wearableId}</span>
                     </div>
                     <div className="inmate-detail-overview__title-section">
                        <Icon
                           name={getBatteryChargeIcon(chargeLevel)}
                           color={IconColor.COOL_GRAY}
                           size="24"
                        />
                        <div className="inmate-detail-overview__title-battery-level">
                           {chargeLevel}%
                        </div>
                     </div>
                     {/* <Icon
                        name="edit"
                        size="16"
                        color={IconColor.HONOLULU_BLUE}
                        onClick={openWearableModal}
                     /> */}
                  </div>
                  <div>
                     <h2>{title}</h2>
                  </div>
               </div>
            </GridItem>
            <GridItem
               size={2}
               className="inmate-detail-overview__detail"
            >
               {jmsEnabled && (
                  <>
                     <div className="inmate-detail-overview__detail-row">
                        Booking number:
                        <span className="inmate-detail-overview__detail-value">
                           {bookingNumber ?? " "}
                        </span>
                     </div>
                     <div className="inmate-detail-overview__detail-row">
                        Global jacket number:
                        <span className="inmate-detail-overview__detail-value">
                           {inmateNumber ?? " "}
                        </span>
                     </div>
                     <div className="inmate-detail-overview__detail-row">
                        Housing/Location:
                        <span className="inmate-detail-overview__detail-value">
                           {housingLocation ?? " "}
                        </span>
                     </div>
                  </>
               )}
            </GridItem>
         </Grid>
         {/* <WearablesModal
            mode={WearableModalType.MANUAL_ASSIGN}
            openModal={isWearableModalOpen}
            handleCloseModal={closeWearableModal}
            inmateId={inmateId}
         /> */}
      </>
   )
}

export default Controls
